import React from 'react';

import {StepEditFieldProps} from '../commonprops';
import {StepEditGenericChoicesField} from '../generic-choices-fields';

export function StepEditRadiobuttonField(
  props: StepEditFieldProps
): JSX.Element {
  return <StepEditGenericChoicesField {...props} inputType="radio" />;
}
